import { type ActionItem } from 'shared/ui'
import {
  type CustomFieldRow,
  editCustomFieldAction,
  deleteCustomFieldAction,
} from 'entities/CustomField'

export const getCustomFieldsTableActions = (
  row: CustomFieldRow,
  onEditSuccess: () => Promise<void>,
  onDeleteSuccess: () => Promise<void>
): ActionItem[] => {
  if (!row.isCustom || row.apiId === null) return []

  const { apiId, name, fieldType, visible } = row

  return [
    {
      icon: 'edit',
      text: 'Edit',
      onAction: () =>
        editCustomFieldAction(
          {
            editId: apiId,
            name,
            fieldType,
            visible,
          },
          onEditSuccess
        ),
    },
    {
      icon: 'delete',
      text: 'Delete',
      onAction: () => deleteCustomFieldAction(apiId, onDeleteSuccess),
    },
  ]
}
